export const JWTTokenConfig = {
    tokenType: 'Bearer',
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken',
    storageUserKeyName: 'userData',
    currnetUrl: 'currnetUrl',

    // storageUserOrgKeyName: 'userOrgData'

};